/** 教务中心 - 机构身份路由 **/

//
const Teacherskq = () => import('@pv/eduCenter/service/attendance/Teacherskq');

//  教务中心-平台服务-服务签约
const Signing = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/eduCenter/platform/Signing.vue'
  );
//  教务中心-平台服务-服务协议管理
const AgreementManage = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/eduCenter/platform/AgreementManage.vue'
  );
//  教务中心-平台服务-服务协议管理 - 新增编辑
const AgreementEdit = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/eduCenter/platform/AgreementEdit.vue'
  );
//  教务中心-平台服务-服务协议管理 - 协议上传管理
const AgreementPdf = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/eduCenter/platform/AgreementPdf.vue'
  );
export default [
  // 教师考勤
  {
    path: '/eduCenter/serviceAttendance/index',
    name: 'eduCenter_serviceAttendance_index',
    meta: { title: '教师考勤' },
    component: Teacherskq
  },
  //
  {
    path: '/eduCenter/platform/signing',
    name: 'eduCenter_platform_signing',

    meta: {
      title: '服务签约记录',
      activePath: '/eduCenter/platform/signing',
      breadcrumb: '教务中心-平台服务-服务签约记录'
    },
    component: Signing
  },
  // 学校端
  {
    path: '/eduCenter/platform/signing',
    name: 'eduCenter_platform_schsigning',

    meta: {
      title: '服务签约记录',
      activePath: '/eduCenter/platform/signing',
      breadcrumb: '教务中心-平台服务-服务签约记录'
    },
    component: Signing
  },
  // 机构端
  {
    path: '/eduCenter/platform/signing',
    name: 'eduCenter_platform_orgsigning',

    meta: {
      title: '服务签约记录',
      activePath: '/eduCenter/platform/signing',
      breadcrumb: '教务中心-平台服务-服务签约记录'
    },
    component: Signing
  },

  //
  {
    path: '/eduCenter/platform/agreementManage',
    name: 'eduCenter_platform_agreementManage',

    meta: {
      title: '服务协议管理',
      activePath: '/eduCenter/platform/agreementManage',
      breadcrumb: '教务中心-平台服务-服务协议管理'
    },
    component: AgreementManage
  },
  {
    path: '/eduCenter/platform/agreementManage/add',
    name: 'eduCenter_platform_agreementManageAdd',

    meta: {
      title: '创建服务协议',
      activePath: '/eduCenter/platform/agreementManage',
      breadcrumb: '教务中心-平台服务-服务协议管理-创建服务协议'
    },
    component: AgreementEdit
  },
  {
    path: '/eduCenter/platform/agreementManage/agreementPdf',
    name: 'eduCenter_platform_agreementPdf',

    meta: {
      title: '协议上传管理',
      activePath: '/eduCenter/platform/agreementManage',
      breadcrumb: '教务中心-平台服务-服务协议管理-协议上传管理'
    },
    component: AgreementPdf
  }
];
